import ReviewItem, { ReviewItemProps } from './ReviewItem'
import styles from './styles.module.scss'
import htmr from 'htmr'
import ScrollCarousel from '@components/ui/ScrollCarousel'

type ReviewsProps = {
  title: string | null
  byline?: string
  reviews: {
    [key: number]: ReviewItemProps
  }
}

export default function Reviews({ title, byline, reviews }: ReviewsProps) {
  const reviewsList = Object.values(reviews)
  return (
    <>
      {!!reviewsList?.length && (
        <div className={styles.Reviews}>
          <div className={styles.Reviews__wrapper}>
            <div className={styles.Reviews__copy}>
              {!!title && (
                <h2 className={styles.Reviews__title}>{htmr(title)}</h2>
              )}
              {byline && <p>{byline}</p>}
              {/* <Link href="">Read all reviews</Link> */}
            </div>

            <div className={styles.Reviews__carousel}>
              <ScrollCarousel
                settings={{
                  buttons: {
                    visible: {
                      mobile: false,
                      desktop: true
                    },
                    position: 'bottom'
                  },
                  overflow: true,
                  loop: true,
                  align: 'start',
                  progressBar: true,
                  containScroll: 'keepSnaps'
                }}
                classes={styles.Reviews__scrollCarousel}
              >
                {reviewsList.map(review => (
                  <ReviewItem
                    key={`review-${review.author}-${review.stars}`}
                    {...review}
                  />
                ))}
              </ScrollCarousel>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
